/*
HTML escaping is the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

const ESCAPED_CHARS = {
    '&' : '&amp;',
    '>' : '&gt;',
    '<' : '&lt;',
    '"' : '&quot;',
    '\'': '&#x27;'
};

const UNSAFE_CHARS_REGEX = /[&><"']/g;

export function escape(str) {
    return ('' + str).replace(UNSAFE_CHARS_REGEX, (match) => ESCAPED_CHARS[match]);
}

export function filterProps(props, whitelist, defaults = {}) {
    return whitelist.reduce((filtered, name) => {
        if (props.hasOwnProperty(name)) {
            filtered[name] = props[name];
        } else if (defaults.hasOwnProperty(name)) {
            filtered[name] = defaults[name];
        }
        return filtered;
    }, {});
}

/*
First check if { path: { nested: 'content' }} exists to be returned,
or return 'path.nested' key’s content (previous default behavior)
*/
export function getMessage(messages, messagePath) {
    let message;

    try {
        const deepMessage = messagePath.split('.').reduce((namespace, prop) => {
            return namespace && namespace[prop];
        }, messages);

        if (typeof deepMessage !== "string") {
            throw new Error("Path not found");
        }

        message = deepMessage;
    } catch(e) {
        message = messages[messagePath];
    }

    return message;
}
